import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import DropDown from '/src/components/UI/DropDown/DropDown';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import Button from "/src/components/UI/Button/Button";
import channelService from "../../../services/channelService"
import IconButton from "/src/components/UI/Button/IconButton/IconButton"; // pour les couleurs des hover button, a ne pas supp
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import { useModal } from "@ebay/nice-modal-react"
import "./ChannelWeb.css"
import TextInput from "/src/components/UI/TextField/TextInput"
import "/src/features/plugins/integrations/components/IntegrationCodeLine/IntegrationCodeLine.css";
import { env } from '../../../../../../var/env';
import InputRange from "/src/components/UI/InputRange/InputRange";
import { isPwa } from "/src/utils/isPwa";

import CheckBox from '/src/components/UI/CheckBox/CheckBox';

const ChannelWeb = (({ channel }) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const { register, setError, clearErrors, handleSubmit, control, formState: { errors }, formState, getValues, setValue, watch } = useForm({
        mode: "onChange",
        defaultValues: {
            color: channel.data?.color,
            name : channel.name,
            sound_effect : channel.data.sound_effect,
            notification : channel.data.notification,
            ripple_effect : channel.data.ripple_effect,
        },
    });

    const toast = useToastDispatchContext();
    const { updateChannel } = channelService;
    const [file, setFile] = useState(channel.data?.avatar);
    const [runBotState,setRunBotState]=useState(channel.data?.delay_run_chatbox??0)

    var host = location.protocol + "//" + location.hostname + ':' + location.port;
    const url_test_chatbox = host + "/bot/test/" + channel.bot.company.id + '-' + channel.bot.id + '-' + channel.key;
    host = env.REACT_APP_API_PROD_PATH;
    const url_exploit_chatbox = host + "/chatbox/web?key=" + channel.key;

    const handleInputRangeChange = (name, value) => {
        setRunBotState(parseInt(value));
        setValue('run_bot_delay',parseInt(value));
    };
    const onSubmit = async () => {
        let formData = new FormData();

        formData.append("name", getValues("name"))
        formData.append("color", getValues("color"));
        formData.append("delay_run_chatbox", getValues("run_bot_delay"))
        formData.append("sound_effect", getValues("sound_effect"))
        formData.append("notification", getValues("notification"))
        formData.append("ripple_effect", getValues("ripple_effect"))

        if (file != null && file.name != null) { // if image doesn't change, not need to add it
            formData.append("avatar", file);
        }

        let [response, error] = await updateChannel(channel.id, formData)
        if (error !== null) {
            console.log(error);
            return;
        }

        modal.resolve(response); // marche sans ... a voir pourquoi
        onClose();
        return;
    }
    const text = "<script src=\"" + url_exploit_chatbox + "\" async></script>";

    return (
        <>
            <Form className="form-container_sideModal" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title className="title_channelTel">Channel Web Information</Form.Title>
                <Form.Body className="form-body_container_sideModal channel_form-body scroll_body_channel">
                    <br></br>
                    <div className="modal-bar" style={{ display: "block" }}>
                        <div style={{ display: 'flex' }}>
                            <Field label="Script for your website" listLabelClassName="title_form title_dropdown" />

                            <a target={ isPwa() ? '_self' : '_blank'} href={url_test_chatbox} className="container-debug-channel"> <span className="debug-channel add-hover" style={{ fontSize: "22px" }}> </span> </a>

                        </div>
                        <div className="integration integration_channelWeb">
                            <pre className="pre code code-url">
                                <code className="hover_copy channel-web-window" onClick={(e) => navigator.clipboard.writeText(text).then(_ => { toast.success('Copy link to clipboard', 'You can paste this link where you need !'); })}>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <span id="hoverText" className="fa fa-copy text_copy" aria-hidden="true"></span>
                                        <span id="hoverIcon" className="fa fa-code icon_copy" aria-hidden="true"></span>
                                    </div>
                                </code>
                            </pre>
                        </div>
                        <Field label="Click, copy and paste the script after the </body> in your html file" listLabelClassName="indication_web_link title-weigth"></Field>


                    </div>

                    <div>
                        <Field label="Informations" listLabelClassName="title_form title_dropdown" />
                    </div>
                    <div>
                        <div>
                            <Field label={<span> Name <span className="obligatory_field">*</span> </span>} listLabelClassName="title-weigth label_color">
                                <TextInput {...register('name', { required: true, minLength: 3 })} style={{ width: "85%", marginBottom: "0", borderColor: errors.name ? "red" : "" }} />
                                <span className='error' style={{ marginRight: "40px",fontSize: "14px" }}>{errors.name ? (errors.name.message ? errors.name.message : "At least 3 letters") : ""}</span>
                            </Field>
                        </div>
                        <div className="color_container">
                            <Field label="Color of my chatbox" listLabelClassName="title-weigth label_color" listClassName="field_color" />
                            <div className="color_area">
                                <div className="input_color-container">
                                    <input  {...register('color')} defaultValue={channel.color} type="color" className="input_color"></input>
                                </div>
                            </div>
                        </div>

                        <div className="run_bot_block" style={{marginTop:'1rem',alignItems:'flex-start'}}>
                                <Field label="Automatic bot opening delay" />
                                <div className="input-range-container" style={{marginTop:'0'}}>
                                    <InputRange  {...register('run_bot_delay')}  _setValue={handleInputRangeChange} value={channel.data?.delay_run_chatbox}  min="0" max="10" />
                                    <span className="range-value" style={{left:`${(runBotState / 10) * 100}%`}}>
                                        {runBotState}
                                    </span>
                                </div>
                        </div>

                       <div className="chatbox_parameter" style={{marginTop:'1rem',alignItems:'flex-start'}}>
                            <Field label="Enable Sound Effect" listLabelClassName="titles-input" listClassName="flex no-margin_left">
                                <CheckBox {...register('sound_effect')} name="sound_effect" checked={!!watch('sound_effect')} onChange={e => setValue('sound_effect', e.target.checked ? true : false)}/>
                            </Field>
                            <Field label="Enable Notification" listLabelClassName="titles-input" listClassName="flex no-margin_left">
                                <CheckBox {...register('notification')} name="notification" checked={!!watch('notification')} onChange={e => setValue('notification', e.target.checked ? true : false)}/>
                            </Field>
                            <Field label="Enable Ripple Effect" listLabelClassName="titles-input" listClassName="flex no-margin_left">
                                <CheckBox {...register('ripple_effect')} name="ripple_effect" checked={!!watch('ripple_effect')} onChange={e => setValue('ripple_effect', e.target.checked ? true : false)}/>
                            </Field>
                        </div>

                        <div>
                            <Field label="Avatar of my chatbox" listLabelClassName="title-weigth label_color" listClassName="field_avatar" />
                            <ChooseFile _setFile={setFile} defaultValueImage={channel.data?.avatar} accept=".png,.jpg,.jpeg" colorBorder={"inset 0 0 0 1px #dddddd;"}></ChooseFile>

                        </div>

                    </div>
                </Form.Body>
                <Form.Buttons>
                    <Button id="form_tel" type="submit" label="Update" className="validate" disabled={!formState.isValid} style={{marginTop:"2rem"}}/>
                </Form.Buttons>
            </Form >
        </>
    )
});

export default ChannelWeb;